import React from "react";
import { useTheme } from "@mui/material/styles";
import type { PurchaseOrder } from "../pages/PurchaseOrdersListPage";

type Props = {
  orders: PurchaseOrder[];
  loading?: boolean;
  onRowClick?: (id: string) => void;
};

const PurchaseOrderTable: React.FC<Props> = ({ orders, loading, onRowClick }) => {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  return (
  <div className={`overflow-x-auto rounded shadow border ${dark ? 'bg-slate-900 border-slate-700' : 'bg-white border-slate-200'}`}>
    <table className={`min-w-full text-sm ${dark ? 'text-slate-100' : 'text-slate-900'}`}>
      <thead className={`${dark ? 'bg-slate-800 text-slate-200' : 'bg-slate-50 text-slate-700'}`}>
        <tr>
          <th className="text-left px-3 py-2">PO Number</th>
          <th className="text-left px-3 py-2">Supplier</th>
          <th className="text-left px-3 py-2">Status</th>
          <th className="text-left px-3 py-2">Created</th>
          <th className="text-left px-3 py-2">Total</th>
        </tr>
      </thead>
      <tbody className={`divide-y ${dark ? 'divide-slate-800' : 'divide-slate-200'}`}>
        {orders.map(po => (
          <tr
            key={po._id}
            className={`${dark ? 'hover:bg-slate-800' : 'hover:bg-slate-50'} cursor-pointer`}
            onClick={() => onRowClick?.(po._id)}
          >
            <td className="px-3 py-2">{po.orderNumber || `PO-${po._id.slice(-6).toUpperCase()}`}</td>
            <td className="px-3 py-2">{typeof po.supplier === 'string' ? po.supplier : (po.supplier?.name || '')}</td>
            <td className="px-3 py-2 capitalize">{po.status}</td>
            <td className="px-3 py-2">{new Date(po.createdAt).toLocaleDateString()}</td>
            <td className="px-3 py-2">${(po.totalAmount ?? (po.items?.reduce((s: number, it: any) => s + (Number(it.unitPrice) || 0) * (Number(it.quantity) || 0), 0) ?? 0)).toFixed(2)}</td>
          </tr>
        ))}
        {!orders.length && !loading && (
          <tr>
            <td colSpan={5} className="text-center text-slate-500 py-8">No purchase orders</td>
          </tr>
        )}
      </tbody>
    </table>
    {loading && <div className={`text-center py-6 ${dark ? 'text-blue-300' : 'text-blue-600'}`}>Loading...</div>}
  </div>
)};

export default PurchaseOrderTable;
